import React from 'react';
import {
  Label,
  RadioGroup,
  RadioGroupItem,
  Textarea,
} from '@roger/ui-components';

interface RadioOption {
  readonly value: string;
  readonly label: string;
}

interface RadioButtonFormSectionProps {
  label: string;
  htmlFor: string;
  value: string;
  onChange: (value: string) => void;
  options: readonly RadioOption[];
  explanationValue: string;
  onExplanationChange: (value: string) => void;
  explanationLabel?: string;
  explanationPlaceholder?: string;
}

const RadioButtonFormSection: React.FC<RadioButtonFormSectionProps> = ({
  label,
  htmlFor,
  value,
  onChange,
  options,
  explanationValue,
  onExplanationChange,
  explanationLabel = 'Please explain:',
  explanationPlaceholder = 'Enter explanation...',
}) => {
  return (
    <div className='space-y-2'>
      <Label className='text-sm font-medium'>{label}</Label>
      <RadioGroup value={value} onValueChange={onChange} className='flex gap-4'>
        {options.map(option => (
          <div key={option.value} className='flex items-center space-x-2'>
            <RadioGroupItem
              value={option.value}
              id={`${htmlFor}-${option.value.toLowerCase()}`}
            />
            <Label
              htmlFor={`${htmlFor}-${option.value.toLowerCase()}`}
              className='font-normal cursor-pointer'
            >
              {option.label}
            </Label>
          </div>
        ))}
      </RadioGroup>
      <div>
        <Label
          htmlFor={`${htmlFor}-explanation`}
          className='text-xs text-muted-foreground'
        >
          {explanationLabel}
        </Label>
        <Textarea
          id={`${htmlFor}-explanation`}
          value={explanationValue}
          onChange={e => onExplanationChange(e.target.value)}
          placeholder={explanationPlaceholder}
          textareaSize='default'
          rows={2}
        />
      </div>
    </div>
  );
};

export default RadioButtonFormSection;
